import { useField, useForwardingRef } from '@arc/frontend/util-common';
import { FormControl } from '../FormControl';
import { Multiselect } from './Multiselect';
export function MultiselectWithControl({
  // FormControlProps
  label,
  helperStyle,
  outerStyle,
  // Other
  name,
  defaultValue,
  onInputChange,
  inputRef: inputRefProp,
  // MultiselectProps
  ...multiselectProps
}) {
  const {
    field: {
      onChange,
      value,
      ref: inputRefRhf
    },
    fieldState: {
      invalid: error
    },
    errorMessage
  } = useField({
    name,
    defaultValue
  });
  const inputRef = useForwardingRef(null, [inputRefRhf, inputRefProp]);
  return <FormControl error={error} helperText={errorMessage} label={label} helperStyle={helperStyle} outerStyle={outerStyle}>
			<Multiselect {...multiselectProps} name={name} inputRef={inputRef} value={value || []} onChange={onChange} onInputChange={onInputChange ? (_event, newValue) => {
      onInputChange(newValue);
    } : undefined} />
		</FormControl>;
}